import { useEffect } from 'react';
import omit from 'lodash/omit';

import { useSetOnChange } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';
import { OMITTED_FIELDS } from 'Stores/SavedFiltersStore/SavedFilters.conf';
import useSavedFiltersStore, {
	useSavedFilters,
	useSetIsUniqueFilterInStore,
} from 'Stores/SavedFiltersStore/SavedFiltersStore';
import { applyFilterStoreDefaults } from 'Stores/StoresContext/StoresContext.helpers';
import { isObjectUnique } from 'Utilities/helpers';
import useStoreToast from 'Utilities/hooks/useStoreToast';

export const setIsCurrentFilterUnique = (nextFilters, savedFilters, setIsUniqueFilter) => {
	const savedFiltersData = savedFilters.map((filter) => filter.filterData);
	const defaultFilters = applyFilterStoreDefaults();
	const isUnique = isObjectUnique({
		ignoreArrayOrder: true,
		object: omit(nextFilters, OMITTED_FIELDS),
		otherObjects: [...savedFiltersData, omit(defaultFilters, OMITTED_FIELDS)],
	});
	setIsUniqueFilter(isUnique);
};

export const useSetIsUniqueFilter = () => {
	useStoreToast(useSavedFiltersStore);
	const setIsUniqueFilter = useSetIsUniqueFilterInStore();
	const setOnChange = useSetOnChange();
	const savedFilters = useSavedFilters();

	useEffect(() => {
		setOnChange((nextFilters) => setIsCurrentFilterUnique(nextFilters, savedFilters, setIsUniqueFilter));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};
